var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassHigh = function SvgIconHourglassHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3.75A1.75 1.75 0 0 1 6.75 2h10.5A1.75 1.75 0 0 1 19 3.75v3.344a1.76 1.76 0 0 1-.695 1.39l-.002.001L13.657 12l4.648 3.516a1.76 1.76 0 0 1 .695 1.39v3.344A1.75 1.75 0 0 1 17.25 22H6.75A1.75 1.75 0 0 1 5 20.25v-3.381a1.76 1.76 0 0 1 .695-1.39l.005-.004L10.333 12 5.695 8.521A1.76 1.76 0 0 1 5 7.131V3.75m10.96 4-3.963 2.998L8 7.75zm1.04-2V4H7v1.75zM7 17l4.997-3.748L17 17.037V20H7z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassHigh;